module.exports = __webpack_public_path__ + "img/btn-tower@1x.9fb06c58.png";